/*
* @Author: tengmaoqing
* @Date:   2018-05-30 19:09:51
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-27 11:25:48
*/

// 回收相关配置
export const RECYCLE_TYPE = {
  SF: '1',
  SM: '2',
  POST_SELF: '3',
  NESTS: '4', // 蜂巢
  CHINAPOST: '5' // 速递易
};

/**
 * 全部支付方式
 *
 *  1  网银
 *  2  支付宝
 *  3  兑换码
 *  4  代金券
 *  5  购机券
 *  6  湖北移动购机券
 *  7  华为代金券
 *  8  湖北电信代金券
 *  9  微信支付
 *  10  微信支付-预付款
 *  11  合作商垫付
 *  12  回收宝刷卡
 *  13  中国电信F码
 *  14  不付款
 *  15  努比亚代金券
 *  16  京东E卡
 *  17  微回收资金池
 *  18  京东钱包
 *  19  vivo代金券
 *  20  ticwatch代金券
 *  21  分期乐代金券
 *  22  oppo代金券
 *  23  天猫红包
 *  24  分期乐新机抵扣金
 *  26  回收宝钱包
 *
 * 需要额外字段的支付方式枚举
 * @type {Object}
 */
export const PAY_TYPE = {
  bank: '1',
  Alipay: '2',
  WeChat: '9',
  FQLCoupon: '21',
  FQLDeductible: '24',
  HsbWallet: '26'
};

export const COMPANY_INFO = {
  TEL: '4006612099',
  SF_TEL: '18123877635',
  ADDR: '深圳市福田区田面国际文创小镇11栋4楼回收宝验机中心',
  POST_CODE: '邮编：518040'
};

export const LOGIN_TYPE = {
  NUBIA: 'nubia',
  FQL: 'fql'
};

export const CATE_TYPE = {
  MOBILE: '1',
  COMPUTER: '2',
  NOTE: '3'
};



// WEBPACK FOOTER //
// ./src/system/const/recycle.js